import React from 'react';
import { motion } from 'framer-motion';

export function WarrantyExclusions() {
  const exclusions = [
    "Damage caused by accidents or trauma",
    "Neglect or poor oral hygiene",
    "Noncompliance with dentist recommendations",
    "Modifications made by another provider",
    "Loss of appliances (like night guards or retainers)"
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="bg-gradient-to-br from-teal-50 to-green-50 py-16 px-6 shadow-inner">
      <div className="max-w-3xl mx-auto text-center space-y-8">
        <div className="relative">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-700 inline-block">
            What's Not Covered
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-teal-400 to-green-400 mx-auto mt-2 rounded-full"></div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 relative overflow-hidden">
          {/* Decorative SVG in corner */}
          <div className="absolute -top-6 -right-6 opacity-10 w-32 h-32">
            <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M80,35 C80,25 75,15 65,10 C55,5 45,5 35,10 C25,15 20,25 20,35 C20,45 25,55 35,60 L50,95 L65,60 C75,55 80,45 80,35 Z" fill="#0cb3c4" />
              <path d="M50,30 C45,30 40,25 40,20 C40,15 45,10 50,10 C55,10 60,15 60,20 C60,25 55,30 50,30 Z" fill="#0cb3c4" />
            </svg>
          </div>

          <motion.ul 
            className="text-left space-y-4 mt-6 relative z-10"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {exclusions.map((item, i) => (
              <motion.li 
                key={i}
                variants={itemVariants}
                className="flex items-start"
              >
                <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gradient-to-r from-teal-500 to-green-400 flex items-center justify-center mt-0.5">
                  <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
                <span className="ml-3 text-gray-700">{item}</span>
              </motion.li>
            ))}
          </motion.ul>

          <div className="mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500">
            For any questions about warranty coverage, please contact our office.
          </div>
        </div>
      </div>
    </section>
  );
}